const CHUNK_RELOAD_STORAGE_KEY = 'hhcd:chunk-auto-reload-at';
const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error || '');
  return /loading chunk timed out|chunkloaderror|failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module/i.test(message);
};

export const shouldAutoReloadChunk = (
  error: unknown,
  lastReloadAt: number,
  now = Date.now(),
): boolean => (
  isChunkLoadError(error)
  && (!Number.isFinite(lastReloadAt) || lastReloadAt <= 0 || now - lastReloadAt >= CHUNK_RELOAD_COOLDOWN_MS)
);

export const autoReloadForChunkError = (error: unknown): boolean => {
  if (!isChunkLoadError(error)) return false;

  let lastReloadAt = 0;
  try {
    lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) || 0);
  } catch {
    // WebView may disable sessionStorage. Reload recovery must still work.
  }
  if (!shouldAutoReloadChunk(error, lastReloadAt)) return false;

  try {
    window.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(Date.now()));
  } catch {
    // Ignore storage failures and still perform the reload.
  }
  window.location.reload();
  return true;
};

export const forceReloadForChunkError = () => {
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
  } catch {
    // Ignore storage failures in restricted WeCom WebViews.
  }
  window.location.reload();
};
